const state = {
  dn: false,
  station: null,
  stationName: null,
};

const mutations = {
  SET_DN: (state, v) => {
    state.dn = v;
  },
  SET_STATION: (state, v) => {
    state.station = v;
  },
  SET_STATIONNAME: (state, v) => {
    state.stationName = v;
  },
};

const actions = {
  setdn({
    commit
  }, v) {
    commit("SET_DN", v);
  },
  setStation({
    commit
  }, v) {
    commit("SET_STATION", v);
  },
  setStationName({
    commit
  }, v) {
    commit("SET_STATIONNAME", v);
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions
};



// WEBPACK FOOTER //
// ./src/store/modules/gis.js